import logo from '../assets/images/logo.svg';

const Logo = () => {
  return <img className='logo' src={logo} alt='logo' />;
};
export default Logo;
